var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync, Prop } from 'vue-property-decorator';
import { BRow, BCol, BFormRadio, BAlert } from 'bootstrap-vue';
import axios from 'axios';
import TabHeading from 'components/picture-frames/Tabs/TabHeading.vue';
import GlazingOptionComponent from 'components/picture-frames/Tabs/GlazingOptions/GlazingOption.vue';
let GlazingOptions = class GlazingOptions extends Vue {
    selectedGlazing;
    rebateDimensions;
    hasMount;
    glazingOptions = {
        Acrylic: [],
        Glass: []
    };
    get selectedType() {
        if (this.selectedGlazing == null) {
            return null;
        }
        return this.glazingOptions.Acrylic
            .filter(ag => ag.id == this.selectedGlazing.id)
            .length > 0 ? 'Acrylic' : 'Glass';
    }
    async mounted() {
        // Get glazing options
        let { data } = await axios
            .get('/api/materials/sheets/glazings');
        this.glazingOptions = data;
    }
};
__decorate([
    ModelSync('glazing', 'change', { type: Object })
], GlazingOptions.prototype, "selectedGlazing", void 0);
__decorate([
    Prop(Object)
], GlazingOptions.prototype, "rebateDimensions", void 0);
__decorate([
    Prop(Boolean)
], GlazingOptions.prototype, "hasMount", void 0);
GlazingOptions = __decorate([
    Component({
        components: {
            BRow, BCol, BFormRadio, BAlert,
            TabHeading, GlazingOptionComponent
        }
    })
], GlazingOptions);
export default GlazingOptions;
